import { Profile } from "./profile.model";
import { ElementType } from "src/app/_core/models/ToolboxModel";
import { SvgParams } from "src/app/_core/constants/constants";
import { ProjectTemplate } from '../../template';
import { LayerLevel } from "../../interfaces/LayerLevel";

export class BarBlendProfile extends Profile {

  get optionName(): string {
      return "";
  }

  get name(): string {
    return "";
  }

  get type() {
    return ElementType.ExtraOption;
  }
  
  get layer(): LayerLevel {
    return LayerLevel.Construction;
  }

  get widthScaled(){
    return this.width * SvgParams.SCALE;
  }

  public weight: number;

  constructor(template: ProjectTemplate, configId: string) {
    super();

    var def = template.hiddenExtras.find(b => b.id == configId);
    this.configId = configId;
    this.weight = def.weight;
    this.color = def.color;
    this.width = def.size.width;
  }

}
